import React, { useCallback } from "react"
import { ContentActionDispatcher } from "../../../../../../actiondispacher/content-action-dispacher"
import { IEditorContent } from "../../../../../../types"
import { EditorChatContent } from "./components/editor-chat-content"
import { EditableTypes } from "../../../../../../../../components/templates/chat/interface/content"

interface IProps {
  content: IEditorContent
  prevContent: IEditorContent | null
  isLast: boolean
  actions: ContentActionDispatcher
}

export const Show = (props: IProps) => {
  const getMenuModeIfneeded = useCallback(() => {
    if (EditableTypes.indexOf(props.content.type) > -1) {
      props.actions.clickContent(props.content.uuid)
    }
    // eslint-disable-next-line
  }, [props.content.uuid])

  return (
    <EditorChatContent
      onClick={getMenuModeIfneeded}
      content={props.content}
      prevContent={props.prevContent}
    />
  )
}
